import { styled } from "@mui/material"

export const Selector = styled("div")(() => ({
  marginLeft: "8px",

  "& .MuiFormControl-root .MuiInput-root": {
    minWidth: "70px",
  },
}))
